export default defineNuxtPlugin(() => {
   let registration: Promise<void> | null = null

   const loadChartJs = () => {
      registration ??= import('chart.js').then(
         ({
            BarController,
            BarElement,
            CategoryScale,
            Chart,
            Filler,
            Legend,
            LineElement,
            LinearScale,
            PointElement,
            Title,
            Tooltip,
         }) => {
            Chart.register(
               CategoryScale,
               LinearScale,
               PointElement,
               LineElement,
               BarElement,
               BarController,
               Title,
               Tooltip,
               Legend,
               Filler
            )
         }
      )
      return registration
   }

   return { provide: { loadChartJs } }
})
